import { memo, forwardRef, SVGProps, Ref } from "react";
import { GetBgColor } from "../common";

export const FunIdLogo = memo(
  forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <div className={"svg-container"}>
      <svg width="36" height="36" viewBox="0 0 133 133" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_39_48178)">
          <rect width="133" height="133" rx="32" fill={GetBgColor()} />
          <g clip-path="url(#clip1_39_48178)">
            <rect width="133" height="133" fill="url(#paint0_linear_39_48178)" />
            <path
              d="M28.0464 39.9745C25.4888 32.1957 29.926 23.8443 37.7536 21.7206C45.5812 19.597 53.5516 24.584 55.1813 32.6252L64.4365 78.403C65.638 84.3206 62.0691 90.1666 56.2996 91.7296C50.53 93.2925 44.5582 90.0354 42.6667 84.3087L28.0464 39.9745Z"
              fill="url(#paint1_linear_39_48178)"
            />
            <path
              d="M71.6219 104.971C73.1921 110.853 69.7066 116.902 63.8418 118.477C57.9771 120.052 51.9458 116.556 50.3755 110.674C48.8052 104.792 52.2908 98.7434 58.1555 97.1686C64.0203 95.5937 70.0516 99.0894 71.6219 104.971Z"
              fill="url(#paint2_radial_39_48178)"
            />
            <path
              d="M64.2164 31.9506C64.2177 31.9518 64.2162 31.9538 64.2146 31.9531C56.1337 28.2982 57.0875 16.4938 65.6499 14.1919C67.9578 13.5715 70.4202 13.8578 72.5377 14.9912L93.2488 26.0867C105.323 32.5651 109.059 48.1584 101.219 59.4209L85.3022 82.2919C84.3267 83.6998 82.8754 84.7139 81.2219 85.1553C74.798 86.8852 69.6351 79.7626 73.2396 74.1672L83.2204 58.6693C87.9907 51.2723 85.0643 41.346 77.0463 37.731L64.2182 31.9481C64.2166 31.9474 64.2152 31.9494 64.2164 31.9506Z"
              fill="url(#paint3_linear_39_48178)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_39_48178"
            x1="55.0633"
            y1="6.78448e-08"
            x2="66.4122"
            y2="159.725"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4041E5" />
            <stop offset="1" stop-color="#023DCA" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_39_48178"
            x1="34.0466"
            y1="66.833"
            x2="63.0494"
            y2="59.6874"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF0095" />
            <stop offset="1" stop-color="#FE06D6" />
          </linearGradient>
          <radialGradient
            id="paint2_radial_39_48178"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(67.9187 101.043) rotate(131.295) scale(21.067 21.0059)"
          >
            <stop stop-color="#F9E004" />
            <stop offset="1" stop-color="#D9BB13" />
          </radialGradient>
          <linearGradient
            id="paint3_linear_39_48178"
            x1="81.9322"
            y1="7.44628"
            x2="81.9322"
            y2="92.8046"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.442308" stop-color="#00FFB5" />
            <stop offset="1" stop-color="#F5DA04" />
          </linearGradient>
          <clipPath id="clip0_39_48178">
            <rect width="133" height="133" rx="32" fill="white" />
          </clipPath>
          <clipPath id="clip1_39_48178">
            <rect width="133" height="133" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  ))
);
